/**
 * What the operating system already knows about this player.
 *
 * Somebody who has turned motion down system-wide has told every application on the machine
 * already, and asking them again through a settings screen they have to find first is asking them
 * to be made ill once before the game will listen. So the media query seeds the default and the
 * knob overrides it, which is the shape a stored setting already has: absent means the default, and
 * a default is allowed to know something.
 *
 * Asked when it is needed rather than captured at import. A function that reads the live query
 * costs nothing next to a copy that would have to be kept in step with the system setting.
 *
 * Absent in Node, which is where the tests run, and the `in` check is what tells the two apart
 * before the property is ever read, the same way [tabTokenStore](../../net/session/tabTokenStore.ts)
 * probes for a storage. Nothing said is the same answer as a player who has not said anything.
 */

const QUERY = '(prefers-reduced-motion: reduce)';

export function prefersReducedMotion(): boolean {
  if (!('matchMedia' in globalThis)) return false;
  return globalThis.matchMedia(QUERY).matches;
}
